import { PRODUCT } from '../../../lib/constants';
import TemplateData, { localsMessages } from './getTemplateData';
import AppStore from '../stores/AppStore';
import { formatCurrencyAsISOFormat, normalizeNumber } from './formator';
import { getPersonalizedMessages } from './personalizedMessages';
import { GN_CONTENT_TOUCHPOINT } from './constants';

const gncMessages = localsMessages('clients/generosityNetworkCharities');

export const isGNC = () =>
  TemplateData.product === PRODUCT.GENEROSITY_NETWORK_CHARITIES;
export const isGN = () => TemplateData.product === PRODUCT.GENEROSITY_NETWORK;
export const isBrandedCampaign = () =>
  TemplateData.product === PRODUCT.BRANDED_CAMPAIGN;
export const isPPFundraising = () =>
  TemplateData.product === PRODUCT.PP_FUNDRAISING;

export const isExternalFlow = () =>
  isGNC() || isGN() || isBrandedCampaign() || isPPFundraising();

export const prepareOrderParams = () => ({
  amount: normalizeNumber(AppStore.getDonationAmount()),
  addressSharingConsent: false,
  currencyCode: AppStore.getDonationCode(),
  currencySymbol: AppStore.getDonationSymbol(),
  donationAmountType:
    AppStore.getDonationAmountType() === 'preset' ? 'preset' : 'userinput',
  donationNote: AppStore.getDonationNote() || '',
  recurring: AppStore.getDonationRecurring(),
  selectedProgram: AppStore.getSelectedProgram(),
  selectedPresetButtonId: AppStore.getSelectedPresetButtonId(),
  token: TemplateData.token,
  anonymousStatus: AppStore.getAnonymousStatus(),
  ppgfMessage: gncMessages?.ppgfMessage,
  directMessage: gncMessages?.directMessage,
});

export const getMaximumDonationAlertMessage = () => {
  const formatedMaximumAmount = formatCurrencyAsISOFormat({
    value: TemplateData.maximumDonationAmount,
    currency: TemplateData.maximumDonationCurrency,
  });
  const alertMessage = gncMessages.maximumAmountAlert.replaceAll(
    '{amount}',
    formatedMaximumAmount
  );

  return alertMessage;
};

export const getPersonalizedNoteToPayeeLabel = () => {
  const psMessages = getPersonalizedMessages(GN_CONTENT_TOUCHPOINT, {
    isHtml: false,
  });
  return psMessages?.noteToPayeeLabel;
};

export const getPersonalizedAnonymousContent = () => {
  const psMessages = getPersonalizedMessages(GN_CONTENT_TOUCHPOINT, {
    isHtml: false,
  });
  return {
    label: psMessages?.anonymousLabel,
    tooltip: psMessages?.anonymousTooltip,
  };
};
